'use strict';

import React from 'react';
import AppConstants from '../../constants/ApplicationConstants';
import YourDetailsActions from '../../actions/YourDetailsActions';
import _ from 'lodash';
import BusinessYourDetailsStore from '../../stores/BusinessYourDetailsStore';
import YourDetailsStore from '../../stores/YourDetailsStore';
import YourDetailsConstants from '../../constants/YourDetailsConstants';
import Products from '../../utils/Products';

import TextInput from '../Common/TextInput.jsx';
import RadioInput from '../Common/RadioInput.jsx';
import Country from '../YourDetails/Country.jsx';
import Tfn from '../Common/Tfn.jsx';
import Address from './Address.jsx';
import TelephoneNumbers from '../Common/TelephoneNumbers.jsx';
import Email from '../Common/Email.jsx';
import AccountDesignation from './AccountDesignation.jsx';

//this only supports "business" account types : SMSF , Trust, and Company
export default class BusinessYourDetails extends React.Component {
    constructor(props){
        super(props);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.componentWillUnmount = this.componentWillUnmount.bind(this);
        this._onChange = this._onChange.bind(this);
        this.updateYourDetailsData = this.updateYourDetailsData.bind(this);
        this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
        this.render = this.render.bind(this);
        this.state = this.getStateFromStore();
    }
    getStateFromStore() {
        return {
            yourDetailsData: BusinessYourDetailsStore.getYourDetailsData(),
            tfnExemptionList: BusinessYourDetailsStore.getTfnExemptionList()          
        };
    }

   
    componentDidMount(){
        BusinessYourDetailsStore.addChangeListener(this._onChange);
        YourDetailsStore.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        BusinessYourDetailsStore.removeChangeListener(this._onChange);
        YourDetailsStore.removeChangeListener(this._onChange);
    }

    _onChange() {
        this.setState(this.getStateFromStore(this.props.accountType, this.props.productId));
    }

    updateYourDetailsData(event) {
        const fieldId = event.target.model;
        const componentId = event.target.id;
        const fieldValue = event.target.value;
        YourDetailsActions.updateYourDetailsData(fieldId, componentId, fieldValue);
    }

    componentWillReceiveProps(nextProps) {
        if (_.isEqual(this.props, nextProps)) {
            return;
        }

        this.setState(this.getStateFromStore(nextProps.accountType, nextProps.productId));
    }

    render() {
        if (!this.props.productId || !this.props.accountType) {
            return <span></span>;
        }
        const YesNoRadioData = AppConstants.YesNoRadioData;
        const isAnnuityProduct = Products.isAnnuity(this.props.productId);
        const isInvestmentProduct = Products.isInvestment(this.props.productId);
        const ifApplicable = 'If applicable';

        const isEntityPrimaryBusinessInvesting = isAnnuityProduct ? null : (<RadioInput id="isPrimaryBusinessInvesting"
                                                                                      data={YesNoRadioData}
                                                                                      value={this.state.yourDetailsData.isPrimaryBusinessInvesting}
                                                                                      label="Is the entity's primary business activity investing?"
                                                                                      onChange={this.updateYourDetailsData}
                                                                                      model="isPrimaryBusinessInvesting"
                                                                                      bottomText={this.props.content.yourDetails.primaryBusinessInvestingDefinition}
                                                                                      hideBottomText={!Boolean(this.state.yourDetailsData.isPrimaryBusinessInvesting)}
                                                                                      errorList={this.state.yourDetailsData.errorList} />);

        const abn = (this.props.accountType === AppConstants.AccountTypeCodes.COMPANY || this.props.accountType === AppConstants.AccountTypeCodes.PARTNERSHIP) 
                                                                                  ? (<TextInput label={this.state.yourDetailsData.abnLabel}
                                                                                                id="abn"
                                                                                                value={this.state.yourDetailsData.abn}
                                                                                                onBlur={this.updateYourDetailsData}
                                                                                                errorList={this.state.yourDetailsData.errorList}
                                                                                                isDisabled={this.state.yourDetailsData.abnReadonly}
                                                                                                model="abn" />) : null;

        const charity = this.props.accountType !== AppConstants.AccountTypeCodes.SMSF ? (<RadioInput label="Is this a charity?"
                                                                                                    id="isCharity"
                                                                                                    data={AppConstants.YesNoRadioData}
                                                                                                    value={this.state.yourDetailsData.isCharity}
                                                                                                    onChange={this.updateYourDetailsData}
                                                                                                    model="isCharity"
                                                                                                    errorList={this.state.yourDetailsData.errorList} />) : null;

        const tfnNumberRightText = this.props.formKey === AppConstants.FormKeys.SMSF_INVESTMENT ||  this.props.formKey === AppConstants.FormKeys.PARTNERSHIP_INVESTMENT ? ifApplicable : undefined;

        return (
            <div>
                <TextInput label={this.state.yourDetailsData.businessNameLabel}
                           id="businessName"
                           value={this.state.yourDetailsData.businessName}
                           onBlur={this.updateYourDetailsData}
                           model="businessName"
                           errorList={this.state.yourDetailsData.errorList} 
                           isDisabled={this.state.yourDetailsData.businessNameReadonly} />
                <TextInput label={this.state.yourDetailsData.businessActivityLabel}
                           id="primaryBusinessActivity"
                           value={this.state.yourDetailsData.primaryBusinessActivity}
                           onBlur={this.updateYourDetailsData}
                           model="primaryBusinessActivity"
                           errorList={this.state.yourDetailsData.errorList}
                           isDisabled={this.state.yourDetailsData.primaryBusinessActivityReadonly} />
                {charity}
                {isEntityPrimaryBusinessInvesting}
                <Country  label="Country established"
                          id="countryEstablished"
                          value={this.state.yourDetailsData.countryEstablished}
                          onBlur={this.updateYourDetailsData}
                          disabled={this.state.yourDetailsData.countryEstablishedReadonly || isAnnuityProduct }
                          model="countryEstablished"
                          errorList={this.state.yourDetailsData.errorList} />
                { (isInvestmentProduct) ? abn : null}
                <Tfn id="tfnInfo"
                     productId={this.props.productId}
                     accountType={this.props.accountType}
                     isMainApplicant={true}
                     hasTfnExemption={this.state.yourDetailsData.hasTfnExemption}
                     hasTfnExemptionReadonly={this.state.yourDetailsData.hasTfnExemptionReadonly}
                     tfnNumber={this.state.yourDetailsData.tfnNumber}
                     tfnNumberReadonly={this.state.yourDetailsData.tfnNumberReadonly}
                     tfnNumberRightText={tfnNumberRightText}
                     tfnExemptionReason={this.state.yourDetailsData.tfnExemptionReason}
                     tfnExemptionReasonReadonly={this.state.yourDetailsData.tfnExemptionReasonReadonly}
                     tfnExemptionList={this.state.tfnExemptionList}
                     hasTfnExemptionRightText={ifApplicable}
                     tfnConsentFlag={this.state.yourDetailsData.tfnConsentFlag}
                     tfnWithConsent={this.state.yourDetailsData.tfnWithConsent}
                     formKey={this.props.formKey}
                     type={(isInvestmentProduct) ? AppConstants.tfnTypes.business : undefined}
                     errorList={this.state.yourDetailsData.errorList} />
                { (isAnnuityProduct) ? abn : null}
                <Address data={this.state.yourDetailsData.addressInfo}
                         accountType={this.props.accountType}
                         errorList={this.state.yourDetailsData.errorList}
                         type={YourDetailsConstants.Values.BUSINESS} />
                <TelephoneNumbers id={this.props.productId + this.props.accountType}
                                  mobileNumber={this.state.yourDetailsData.mobileNumber}
                                  homeNumber={this.state.yourDetailsData.homeNumber}
                                  workNumber={this.state.yourDetailsData.workNumber}
                                  mobileNumberReadonly={this.state.yourDetailsData.mobileNumberReadonly}
                                  homeNumberReadonly={this.state.yourDetailsData.homeNumberReadonly}
                                  workNumberReadonly={this.state.yourDetailsData.workNumberReadonly}
                                  forBusiness={this.props.accountType === AppConstants.AccountTypeCodes.COMPANY && isInvestmentProduct}
                                  showOnlyMobileNumber={this.props.accountType === AppConstants.AccountTypeCodes.TRUST && isInvestmentProduct}
                                  onContactDetailsChange={this.updateYourDetailsData}
                                  isBusiness={true}
                                  errorList={this.state.yourDetailsData.errorList} />
                <Email value={this.state.yourDetailsData.emailAddress}
                       onEmailChange={this.updateYourDetailsData}
                       errorList={this.state.yourDetailsData.errorList}
                       content={this.props.content}
                       isBusiness={true}
                       readonly={this.state.yourDetailsData.emailAddressReadonly}
                       hideWhyWeAskText={isAnnuityProduct} 
                       mandatory={true} />
                <AccountDesignation data={this.state.yourDetailsData} errorList={this.state.yourDetailsData.errorList} />
            </div>
        );
    }
}

BusinessYourDetails.propTypes = {
    productId: React.PropTypes.number.isRequired,
    accountType: React.PropTypes.oneOf([AppConstants.AccountTypeCodes.COMPANY, AppConstants.AccountTypeCodes.SMSF, AppConstants.AccountTypeCodes.TRUST, AppConstants.AccountTypeCodes.PARTNERSHIP])
};



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/BusinessYourDetails.jsx